import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminCartSettingsResponse {
  @jsonMember(Boolean)
  public readonly deleteCartAfterCheckout!: boolean;
}
